import { XSELL_NEW_LAYOUT } from 'shared/experiments/consts/names'
import {
  CSW_ARROW_CLICK,
  CSW_PRODUCT_CLICK,
  CSW_SHOW_MORE_CLICK
} from 'shared/experiments/consts'

import { trackEvent, isExperimentEnabled } from 'shared/experiments/utils'

export default () => {
  if (!isExperimentEnabled(XSELL_NEW_LAYOUT)) {
    return
  }

  const xSellWidgets = document.querySelectorAll(
    '[data-clientside-api-call~="fetchCrossSell"]'
  )

  xSellWidgets.forEach(xSellWidget => {
    xSellWidget.addEventListener('click', event => {
      const { target } = event
      const options = xSellWidget.getAttribute('data-clientside-call-options')
      const widgetId = JSON.parse(options)?.params?.wid

      if (target.closest('[data-clientside-hook~="slider__item"]')) {
        trackEvent(`${CSW_PRODUCT_CLICK} ${widgetId}`)
      }

      if (target.closest('[data-clientside-hook~="showMoreButton"]')) {
        trackEvent(`${CSW_SHOW_MORE_CLICK} ${widgetId}`)
      }
      if (target.closest('[data-clientside-hook~="adaptable__arrows"]')) {
        trackEvent(`${CSW_ARROW_CLICK} ${widgetId}`)
      }
    })
  })
}
